import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const sessionId = params.get("session_id");
        if (!sessionId) {
            navigate("/", { replace: true });
            return;
        }
        (async () => {
            try {
                const res = await api.post("/auth/session", { session_id: sessionId });
                if (res.data?.session_token) {
                    localStorage.setItem("session_token", res.data.session_token);
                }
                setUser(res.data.user);
                // Clear hash
                window.history.replaceState(null, "", window.location.pathname);
                if (!res.data.user?.onboarded) {
                    navigate("/onboarding", { replace: true, state: { user: res.data.user } });
                } else {
                    navigate("/dashboard", { replace: true, state: { user: res.data.user } });
                }
            } catch (e) {
                navigate("/", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-nest-base" data-testid="auth-callback-screen">
            <div className="text-center">
                <div className="h-10 w-10 rounded-full border-2 border-nest-clay border-t-transparent animate-spin mx-auto"></div>
                <p className="mt-4 text-nest-ink2 text-sm tracking-wide">Signing you in…</p>
            </div>
        </div>
    );
}
